<template>
  <div class="iframe-modal">
    <a-modal
      v-model="showModal"
      width="100%"
      wrapClassName="iframe-full-modal"
      :closable="false"
      :keyboard="false"
      :destroyOnClose="true"
      :footer="null"
      :zIndex="9999"
      @ok="() => (showModal = false)"
    >
      <iframe width="100%" height="100%" :src="iframeUrl" frameborder="0" />
    </a-modal>
  </div>
</template>
<script>
import { getDetailsApi } from '../../../api/common/index';
export default {
  name: 'IframeModal',
  data() {
    return {
      url: '/workorder/submittals',
      params: {
        id: '',
      },
      showModal: false,
    };
  },
  computed: {
    iframeUrl() {
      return this.$util.getIframeUrl(this.url, this.params);
    },
  },
  watch: {
    $route: 'getPath',
    showModal: (val) => {
      if (val) {
        document.querySelector('#app').style.height = '100px';
        document.querySelector('#app').style.overflow = 'hidden';
      } else {
        document.querySelector('#app').style.height = 'auto';
        document.querySelector('#app').style.overflow = 'auto';
      }
    },
  },
  created() {},
  mounted() {
    const that = this;
    window.addEventListener('message', function(event) {
      if (typeof event.data === 'string') {
        that.$emit('submit', event.data);
        that.showModal = false;
        //审查意见支付费用兼容
        if (event.data.indexOf('goPay_') !== -1) {
          getDetailsApi({
            workId: event.data.split('_')[1],
          }).then((res) => {
            if (res && res.data && res.data.trademarkOaWorkOrder)
              that.$util.reviewOpinionsGoPay({
                serviceId: res.data.trademarkOaWorkOrder.serviceId,
                trademarkOaPlanVOS: res.data.trademarkOaPlans,
              });
          });
        }
      }
    });
  },
  methods: {},
};
</script>
<style lang="less" scoped></style>

<style lang="less">
.iframe-full-modal {
  height: calc(100vh);
  overflow: hidden;
  .ant-modal {
    max-width: 100%;
    top: 0;
    padding-bottom: 0;
    margin: 0;
  }
  .ant-modal-content {
    display: flex;
    flex-direction: column;
    height: calc(100vh);
  }
  .ant-modal-body {
    flex: 1;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// xcloud-client-components-web/module/iipto/common/IframeModal.vue